/**
 * Company service
 * Handles company-related operations
 */
import APIClient from '../apiClient';

export const fetchAllCompanies = async () => {
  try {
    const response = await APIClient.get(`/products/getAllCompanies`);
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

export const searchCompanies = async (searchTerm, limit = 10) => {
  try {
    const response = await APIClient.get(`/companies/search`, {
      params: { searchTerm, limit }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchProductsByCompany = async (company, page = 1, limit = 20, sort = 'random', supplyCategory = '') => {
  try {
    const response = await APIClient.get(`/products/getProductsByCompany`, {
      params: { company, page, limit, sort, ...(supplyCategory ? { supplyCategory } : {}) },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

